import FlexLayout from "flexlayout-react";
import "flexlayout-react/style/light.css"; // ✅ switch to light theme instead of dark
import "./analyze.css";

import { DashboardProvider } from "./AnalyzeLayoutContext";

import SelectionPanel from "./selectionPanel/SelectionPanel";
import TelemetryPanel from "./telemetryPanel/TelemetryPanel";
import SpacesPanel from "./spacesPanel/SpacesPanel";
import AnalyzePanel from "./analyzePanel/AnalyzePanel";
import InfoPanel from "./infoPanel/InfoPanel";
import DataTab from "./infoPanel/DataTab";

const DashboardLayout = () => {
  const json = {
    global: {
      tabEnableRename: false,
      tabSetEnableDrop: true,
      borderEnableDrop: false,
    },
    borders: [
      {
        type: "border",
        location: "left",
        size: 320,
        show: true,
        selected: 0,
        enableCollapse: false,
        enableDrop: false,
        enableDrag: false,
        children: [
          {
            type: "tab",
            name: "Selection",
            name: "",
            component: "selection",
            enableClose: false,
            enableMaximize: false,
            enableDrag: false,
            enableDrop: false,
          },
        ],
      },
    ],
    layout: {
      type: "row",
      weight: 100,
      children: [
        {
          // LEFT COLUMN (Telemetry + Analyze)
          type: "column",
          weight: 50,
          children: [
            {
              type: "tabset",
              weight: 50,
              children: [
                { type: "tab", name: "Telemetry", component: "telemetry" },
              ],
            },
            {
              type: "tabset",
              weight: 50,
              children: [
                { type: "tab", name: "Analyze", component: "analyze" },
              ],
            },
          ],
        },
        {
          // RIGHT COLUMN (Spaces + Info)
          type: "column",
          weight: 50,
          children: [
            {
              type: "tabset",
              weight: 50,
              children: [
                { type: "tab", name: "Spaces", component: "spaces" },
              ],
            },
            {
              type: "tabset",
              weight: 50,
              children: [
                { type: "tab", name: "Info", component: "info" },
                { type: "tab", name: "Data", component: "dataTab" },
              ],
            },
          ],
        },
      ],
    },
  };

  const model = FlexLayout.Model.fromJson(json);

  const factory = (node) => {
    const component = node.getComponent();
    switch (component) {
      case "selection":
        return <SelectionPanel />;
      case "telemetry":
        return <TelemetryPanel />;
      case "spaces":
        return <SpacesPanel />;
      case "analyze":
        return <AnalyzePanel />;
      case "info":
        return <InfoPanel />;
      case "dataTab":
        return <DataTab />;
      default:
        return <div>Unknown panel</div>;
    }
  };

  return (
    <DashboardProvider>
      <div style={{ height: "calc(100vh - 52px)", width: "100vw", background: "#f7f7f7" }}>
        <FlexLayout.Layout model={model} factory={factory} />
      </div>
    </DashboardProvider>
  );
};

export default DashboardLayout;
